/** @jsx jsx */
import axios from 'axios'
import { jsx, Input, Button } from 'theme-ui'
import React, { useState } from 'react'
import LinkArrow from '~/icons/linkArrow'

const PeoplevineForm = (props) => {
  const {
    fill = 'currentColor',
    fontSize = [16],
    placeholder = 'Your email'
  } = props
  const [email, setEmail] = useState('')
  const [response, setResponse] = useState({})

  const handleSubmit = (e) => {
    e.preventDefault()

    const data = {
      email
    }

    const debug = false
    const base = debug ? 'https://planque-staging.netlify.app' : ''

    axios
      .post(`${base}/.netlify/functions/subscribe`, JSON.stringify(data))
      .then(function (data) {
        console.log('---', data)
        setResponse(data)
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  const success = response.status === 200

  return (
    <div className="width-100" {...props}>
      {success ? (
        <div>thank you</div>
      ) : (
        <form
          className="width-100"
          onSubmit={(e) => {
            handleSubmit(e)
          }}
          sx={{ display: 'flex' }}
          autoComplete="off"
        >
          <div
            className="rel width-100 footer-newsletter"
            sx={{ display: 'flex', borderBottom: `1px solid ${fill}` }}
          >
            <input
              type="email"
              name="EMAIL"
              value={email}
              placeholder={placeholder}
              onChange={(e) => {
                setEmail(e.currentTarget.value)
              }}
              required
              sx={{
                border: 'none',
                outline: 'none',
                backgroundColor: 'transparent',
                appearance: 'none',
                width: 'calc(100% - 30px)',
                fontSize,
                lineHeight: '30px',
                padding: 0,
                height: '30'
              }}
            />
            <button
              type="submit"
              name="button"
              sx={{ p: 0, color: 'currentColor' }}
            >
              <LinkArrow fill={fill} />
            </button>
          </div>
        </form>
      )}
    </div>
  )
}

export default PeoplevineForm
